import { Asset } from '../models';
import { BaseDAO } from './base.dao';

export class AssetDAO extends BaseDAO<Asset> {}
